// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"Map_mapContainer__yV7KS","loadingContainer":"Map_loadingContainer__CZcYd"};